export default function ProfessorAnalyticsPage() {
  return (
    <div>
      <h1 className="text-2xl font-heading font-bold text-text-primary mb-6">Analytics</h1>
      <p className="text-text-muted">Analytics dashboard coming soon...</p>
    </div>
  );
}

